import { FlowStateManager } from '../../flow-management/FlowStateManager';
import { Step } from '../../views/Step';
import { getRouteParams } from '../../routing/getRouteParams';
export const BranchCookielessWordpress = {
  name: 'BranchCookielessWordpress',
  stateCheck: () => {
    const {
      queryParamsMap
    } = getRouteParams();
    return queryParamsMap.get('cookielessWordpress') === '1';
  },
  rebuildFlow: (flow, state, dispatch) => {
    return dispatch(FlowStateManager.replaceStep(Step.WordpressAuthorization, Step.WordpressConnectRedirect));
  },
  processed: false,
  processedOnStep: null,
  afterData: null,
  afterStep: null
};